import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank-layout',
  templateUrl: './blank-layout.component.html',
  styleUrls: ['./blank-layout.component.scss']
})
export class BlankLayoutComponent implements OnInit {

  constructor() {    
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/containers/blank-layout/blank-layout.component.ts